<ng-container *ngIf="{ isMawChrome: selectedLauncher | isMawChromeLauncher } as launcher">
  <div class="title-lable-container fixed-height justify-content-between">
    <div class="monitor-index uploaded-file" *ngIf="launcher.isMawChrome">1</div>
    <span class="title-lable" [ngClass]="{ 'title-short': launcher.isMawChrome}">
      <img [src]="playlistItem.PlaylistItemLinks[0]?.icon" class="file-icon">
      {{ playlistItem.PlaylistFileName || playlistItem.PlaylistItemTitle }}
    </span>

    <div class="d-flex align-items-center ml-2" *ngIf="launcher.isMawChrome && playlistItem?.PlaylistItemLinks[0]?.File">
      <zoom-input [source]="playlistItem?.PlaylistItemLinks[0]" [item]="playlistItem"></zoom-input>
    </div>

    @if (playlistItem.PlaylistItemLinks[0]?.isConverting && playlistItem.PlaylistItemLinks[0]?.convertingRequest) {
      <div class="d-flex align-items-center ml-2">
        <mat-icon (click)="playlistItem.PlaylistItemLinks[0].convertingRequest.unsubscribe()" class="remove-icon gray"
          svgIcon="cancel_circle" matTooltip="Cancel converting"></mat-icon>
      </div>
    }
    @else {
      <div class="d-flex align-items-center ml-2">
        <mat-icon (click)="removeItem.emit()" class="remove-icon gray"
           svgIcon="close" matTooltip="Remove playlist item"></mat-icon>
      </div>
    }
  </div>

  @if (playlistItem.PlaylistItemLinks[0]?.isConverting) {
    <files-progress-bar [item]="playlistItem" [showDetails]="true" [percentage]="playlistItem.percentage"></files-progress-bar>
  }
  @else {
    <mat-progress-bar mode="determinate" [value]="playlistItem.percentage"></mat-progress-bar>
  }

  <ng-container *ngFor="let source of playlistItem.PlaylistItemLinks.slice(1); let i = index">
    <div class="d-flex items-list" [ngClass]="{ 'row no-gutters': !source.IsFile }">
      <ng-container *ngIf="source.IsFile; else url">
        <div class="monitor-index uploaded-file-list">{{ i + 2 }}</div>

        <select class="file-select" [(ngModel)]="source.FileId" (change)="onSourceChanged(i + 1, $event)">
          <ng-container *ngIf="recentFiles$ | async as files; else loadingFiles">
            <option class="d-none" selected [value]="source.FileId">{{ 'Select a file' }}</option>
            <option *ngFor="let file of files" [ngValue]="file.Id">
              {{file.Title}}
            </option>
            <option *ngIf="!files || !files?.length" disabled>There are no files</option>
          </ng-container>

          <ng-template #loadingFiles>
            <option class="d-none" disabled selected [value]="source.FileId">Loading...</option>
          </ng-template>
        </select>

        @if (source.isConverting) {
          <mat-icon (click)="source.convertingRequest.unsubscribe()" class="ctrl-icon ml-2"
            svgIcon="cancel_circle" matTooltip="Cancel converting"></mat-icon>
        }
        @else {
          <div class="drop-container maw-chrome">
            <div class="d-flex align-items-center">
              <label class="upload-button">
                <input type="file" ngFileSelect [options]="options" (uploadOutput)="onUploadFile($event, i + 1)"
                  [uploadInput]="uploadInput">
                    <mat-icon class="ctrl-icon" svgIcon="upload" matTooltip="Upload a new file">
                    </mat-icon>
              </label>
              <mat-icon class="ml-2 ctrl-icon" (click)="onChangeField(i + 1)" svgIcon="url_small" matTooltip="Add url"></mat-icon>
            </div>
          </div>
        }
      </ng-container>

      <ng-template #url>
        <div class="monitor-index uploaded-file-list">{{ i + 2 }}</div>
        <div class="title-input-wrapper uploaded-files">
          <input #url class="title-input" placeholder="http://" id="URL" name="URL" [(ngModel)]="source.Link"
            (input)="onSourceChanged(i + 1, $event)">
        </div>
        <mat-icon class="ml-auto ctrl-icon" (click)="onChangeField(i + 1)" svgIcon="image" matTooltip="Add file"></mat-icon>
      </ng-template>

      <zoom-input *ngIf="source.File || source.Link" class="ml-auto"
        [source]="source" [item]="playlistItem"></zoom-input>
    </div>

    @if (source?.isConverting) {
      <files-progress-bar [item]="playlistItem" [sourceIndex]="i + 1" [percentage]="source.percentage"></files-progress-bar>
    }
    @else {
      <mat-progress-bar mode="determinate" [value]="source.percentage"></mat-progress-bar>
    }
  </ng-container>

  <div class="form-container" #form [class.form-container-spacing]="launcher.isMawChrome">
    <div class="row" [ngClass]="{ 'mcl-launcher': launcher.isMawChrome && playlistItem.PlaylistItemLinks[0]?.content }">

      <div class="col-12" *ngIf="playlistItem.ExactVideoDuration">
        <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.useExactDuration"
          (change)="onExactDurationChange($event.checked)" name="UseExactDuration" class="light"
          matTooltip="Exact duration for a playlist item">Use Exact Duration
        </mat-checkbox>
      </div>

      <ng-container *ngIf="launcher.isMawChrome">
        <div class="col-12">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsMuted" name="IsMuted"
            class="light" matTooltip="Item will be muted">Mute
          </mat-checkbox>
        </div>
        <div class="col-12">
          <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.IsContentStretched" name="IsContentStretched"
            class="light" matTooltip="Item content will be stretched" (change)="stretchContentChanged.emit(playlistItem)">
            Stretch content
          </mat-checkbox>
        </div>
      </ng-container>

      <div class="col-12">
        <app-launcher-features [launcherFeatures]="playlistItem.launcherFeatures"></app-launcher-features>
      </div>

      <div class="col-12" *ngIf="selectedLauncher && selectedLauncher.IsFullScreen">
        <mat-checkbox [disableRipple]="true" [(ngModel)]="playlistItem.OpenInFullScreen" name="OpenInFullScreen"
          class="light" matTooltip="Is open a playlist item in full screen"> Open in Full Screen</mat-checkbox>
      </div>

      <item-content-preview [item]="playlistItem" [selectedLauncher]="launcher"></item-content-preview>
    </div>

    <div class="form-group row invisible-border" *ngIf="playlistItem.PlaylistItemLinks.length > 1">
      <label for="Name" class="col-md-3" matTooltip="Playlist item name">Name</label>
      <input type="text" class="col-md-5" placeholder="Playlist item name" [(ngModel)]="playlistItemName" id="Name"
        name="Name">
    </div>

    <div class="form-group row invisible-border position-relative" *ngIf="!playlist.IsAndroid">
      <label for="OpenWith" class="col-md-3" matTooltip="Application which will play a playlist item">Open
        With...</label>
      <mat-select class="col-md-5 pr-0" id="OpenWith" [(ngModel)]="selectedLauncher" name="launcher" panelClass="launcher-select"
        placeholder="Default Apps" (selectionChange)="onLauncherChanged()" [disableOptionCentering]="true"
        [disabled]="playlistItem.percentage < appConst.FULLY_DOWNLOADED_FILE">
        <mat-select-trigger>
          <img *ngIf="selectedLauncher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + selectedLauncher.LauncherImage"/>
          <ng-template #icon>
            <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
          </ng-template>
          <span>{{ selectedLauncher?.LauncherTitle }}
            <ng-container *ngIf="selectedLauncher?.LauncherDescription">
              ({{ selectedLauncher.LauncherDescription }})
            </ng-container>
          </span>
        </mat-select-trigger>
        <mat-option value="image" *ngFor='let launcher of launchers | launcherSort' [value]="launcher">
          <img *ngIf="launcher?.LauncherImage; else icon" class="launcher-icon" [src]="iconsPath + launcher.LauncherImage"/>
          <ng-template #icon>
            <mat-icon class="launcher-icon" svgIcon="rocket_launch"></mat-icon>
          </ng-template>
          <span>{{ launcher.LauncherTitle }}
            <ng-container *ngIf="launcher.LauncherDescription">
              ({{ launcher.LauncherDescription }})
            </ng-container>
          </span>
        </mat-option>
        <mat-option *ngIf="!launchers || !launchers.length" disabled>There are no launchers</mat-option>
      </mat-select>

      <mat-icon svgIcon="rocket_launch" class="set-launcher-icon ctrl-icon" matTooltip="Set selected launcher for all items"
        *ngIf="selectedLauncher && showSetLauncherOption && playlistItems.length > 1"
        (click)="setSelectedLauncherForAllItems.emit(selectedLauncher)">
      </mat-icon>

      <mcl-mode-select *ngIf="launcher.isMawChrome && playlistItem?.PlaylistItemLinks[0]?.File" [item]="playlistItem"
        [parentContainer]="form" [rss]="playlistItem.RssConfigs" (changeMode)="onChangeMode($event)">
      </mcl-mode-select>
    </div>

    <div class="form-group row">
      <label for="Duration" class="col-md-3" matTooltip="Playlist item duration">Set Duration</label>
      <div class="col-md-5 invisible-border duration-wrapper">
        <duration-picker [(duration)]="playlistItem.Duration" (dateTimeChanged)="onDurationChanged(playlistItem)">
        </duration-picker>
      </div>
      <mat-icon svgIcon="update_duration" class="update-duration-icon ctrl-icon" matTooltip="Set selected duration for all items"
        *ngIf="showApplyDurationOption && playlistItems.length > 1" (click)="setDurationForAllItems(playlistItem)"></mat-icon>
    </div>

    @if (launcher.isMawChrome || !hasRssForegroundItem) {
      <div>
        <rss-source [playlist]="playlist" [playlistItem]="playlistItem"></rss-source>
      </div>
    }

    <div class="form-group row invisible-border mb-4" *ngIf="!launcher.isMawChrome">
      <label for="CustomParameters" class="col-md-3" matTooltip="Parameters for a playlist item">Custom
        Parameters</label>
      <input type="text" class="col-md-5" id="CustomParameters"
        [(ngModel)]="playlistItem.CustomParameters">
    </div>

    <div class="form-group row col-md-12" *ngIf="playlist.IsAndroid && playlistItem.PlaylistItemLinks?.length">
      <playlist-item-advanced-options [item]="playlistItem"></playlist-item-advanced-options>
    </div>
  </div>
</ng-container>
